/**
 * Theme JavaScript entry point.
 * Vanilla ES modules — no framework. Add small, progressive-enhancement
 * behaviours here or split into web components as the theme grows.
 */

(function () {
  'use strict';

  // Keep the header cart count in sync after AJAX cart updates (if you add them).
  document.addEventListener('cart:updated', function (event) {
    var count = event.detail && event.detail.item_count;
    if (typeof count !== 'number') return;

    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('hidden', count === 0);
    });
  });
})();
